import { Button, Stack } from '@mui/material';
import { FC } from 'react';
import QuicksightTabs from './QuicksightTabs';
import QuicksightOrganizationSelect from './QuicksightOrganizationsSelect';
import RefreshIcon from '@mui/icons-material/Refresh';
import PrintIcon from '@mui/icons-material/Print';
import {
	EmbedDashboardUrlResponse,
	EntityType,
	PartnerEntity,
	QuickSightApplicationTypes,
} from 'type-declarations';
import { useAppDispatch, useAppSelector } from '@app/hooks/useReduxToolkit';
import { printQuicksightDashboard, resetQuicksightDashboard } from 'state-services';
import { useActivePartnerEntity } from '@app/hooks/useActivePartnerEntity';

interface Props {
	embedUrlsDetails: EmbedDashboardUrlResponse[];
	partners: PartnerEntity[];
	disabled: boolean;
	dashboard: QuickSightApplicationTypes;
}

const QuicksightToolbar: FC<Props> = ({ embedUrlsDetails, partners, disabled, dashboard }) => {
	const dispatch = useAppDispatch();
	const activePartnerEntity = useActivePartnerEntity();
	const { selectedDashboardId } = useAppSelector((state) => state.quicksight);

	const resetDashboard = (): void => {
		dispatch(resetQuicksightDashboard(selectedDashboardId));
	};

	const printDashboard = (): void => {
		dispatch(printQuicksightDashboard(selectedDashboardId));
	};
	const isProvider = (): boolean =>
		activePartnerEntity.partnerType === EntityType.PROVIDER_ORGANIZATION;
	return (
		<>
			<Stack
				direction="row"
				sx={{
					justifyContent: 'space-between',
					alignItems: 'center',
				}}
			>
				<QuicksightTabs embedUrlsDetails={embedUrlsDetails} disabled={disabled} />
				<Stack direction="row" spacing={1}>
					<Button startIcon={<RefreshIcon />} disabled={disabled} onClick={resetDashboard}>
						Reset
					</Button>
					<Button startIcon={<PrintIcon />} disabled={disabled} onClick={printDashboard}>
						Print
					</Button>
					{isProvider() && (
						<QuicksightOrganizationSelect
							partners={partners}
							disabled={disabled}
							dashboard={dashboard}
						/>
					)}
				</Stack>
			</Stack>
		</>
	);
};

export default QuicksightToolbar;
